"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchLocation = undefined;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchLocation = exports.SearchLocation = function SearchLocation() {
  var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0, _classCallCheck3.default)(this, SearchLocation);

  (0, _assign2.default)(this, {
    id: json.id,
    lat: json.lat,
    lon: json.lon,
    locationName: json.name || json.main_text,
    placeId: json.place_id,
    mapBounds: json.map_bounds,
    timezone: json.timezone,
    type: json.type
  });
};